import type { ComponentChildren } from 'preact';
import { FaqSection } from '@/flows/marketplace/components/faq-section.js';
import { embedded } from '@/state/config.js';

interface AppShellProps {
  /** Off for the terminal screens (error, redirect-success) — they aren't steps. */
  faq?: boolean;
  children: ComponentChildren;
}

export function AppShell({ faq = true, children }: AppShellProps) {
  const content = (
    <div className="sm-stack sm-shell sm-app-shell">
      {children}
      {faq && <FaqSection />}
    </div>
  );

  // The band spans the host element, so it wraps the column rather than being it. On our hosted
  // pages there is no wrapper at all and the column is the root.
  return embedded.value ? <div className="sm-shell-band">{content}</div> : content;
}
